import React from 'react';

import Field from '../Models/Field';
import ModelPlaceholders from './ModelPlaceholders';
import { SectionWidgetEditable, SectionWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Section';
import { PageBreakWidgetEditable, PageBreakWidget } from '../Components/DynamicFormBuilderScreen/Widgets/PageBreak';
import { FormDescriptionWidgetEditable, FormDescriptionWidget } from '../Components/DynamicFormBuilderScreen/Widgets/FormDescription';
import { FileEmbeddedWidgetEditable, FileEmbeddedWidget } from '../Components/DynamicFormBuilderScreen/Widgets/FileEmbedded';
import { UserNameWidgetEditable, UserNameWidget } from '../Components/DynamicFormBuilderScreen/Widgets/UserName';
import { PropertyNameWidgetEditable, PropertyNameWidget } from '../Components/DynamicFormBuilderScreen/Widgets/PropertyName';
import { PMSPropertyIdWidgetEditable, PMSPropertyIdWidget } from '../Components/DynamicFormBuilderScreen/Widgets/PMSPropertyId';
import { PropertyAddressWidgetEditable, PropertyAddressWidget } from '../Components/DynamicFormBuilderScreen/Widgets/PropertyAddress';
import { TenantIdWidgetEditable, TenantIdWidget } from '../Components/DynamicFormBuilderScreen/Widgets/TenantId'
import { PropertyInfoWidgetEditable, PropertyInfoWidget } from '../Components/DynamicFormBuilderScreen/Widgets/PropertyInfo';
import { UnitNumberWidgetEditable, UnitNumberWidget } from '../Components/DynamicFormBuilderScreen/Widgets/UnitNumber';
import { UnitBuildingWidgetEditable, UnitBuildingWidget } from '../Components/DynamicFormBuilderScreen/Widgets/UnitBuilding';
import { UnitInfoWidgetEditable, UnitInfoWidget } from '../Components/DynamicFormBuilderScreen/Widgets/UnitInfo';
import { TextWidgetEditable, TextWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Text';
import { TextAreaWidgetEditable, TextAreaWidget } from '../Components/DynamicFormBuilderScreen/Widgets/TextArea';
import { CheckboxWidgetEditable, CheckboxWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Checkbox';
import { RadioWidgetEditable, RadioWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Radio';
import { SelectWidgetEditable, SelectWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Select';
import { NumberWidgetEditable, NumberWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Number';
import { CurrencyWidgetEditable, CurrencyWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Currency';
import { SliderRangeWidgetEditable, SliderRangeWidget } from '../Components/DynamicFormBuilderScreen/Widgets/SliderRange';
import { DateWidgetEditable, DateWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Date';
import { DateTimeWidgetEditable, DateTimeWidget } from '../Components/DynamicFormBuilderScreen/Widgets/DateTime';
import { TimeWidgetEditable, TimeWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Time';
import { StarsWidgetEditable, StarsWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Stars';
import { SignatureWidgetEditable, SignatureWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Signature';
import { PhoneWidgetEditable, PhoneWidget } from '../Components/DynamicFormBuilderScreen/Widgets/Phone';
import { FileImageWidgetEditable, FileImageWidget } from '../Components/DynamicFormBuilderScreen/Widgets/FileImage';
import { Rating3ptWidget, Rating3ptWidgetEditable } from '../Components/DynamicFormBuilderScreen/Widgets/Rating3pt';
import { StatsigService } from './StatsigService';

import Utils from './Utils';

// Dynamic async function that checks feature gates at runtime
const getDisabledInputs = async () => {
  const baseInputs = [
    {
      key: 'textInput',
      widget: <TextWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('textInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'textArea',
      widget: <TextAreaWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('textArea'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'checkbox',
      widget: <CheckboxWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('checkbox'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'radio',
      widget: <RadioWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('radio'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'select',
      widget: <SelectWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('select'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'numberInput',
      widget: <NumberWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('numberInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'currencyInput',
      widget: <CurrencyWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('currencyInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'phoneInput',
      widget: <PhoneWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('phoneInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'sliderRange',
      widget: <SliderRangeWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('sliderRange'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'starRate',
      widget: <StarsWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('starRate'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'dateInput',
      widget: <DateWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('dateInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'dateTimeInput',
      widget: <DateTimeWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('dateTimeInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'timeInput',
      widget: <TimeWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('timeInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'fileImageInput',
      widget: <FileImageWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('fileImageInput'), disabled: true })} isDisabled={true} />
    },
    {
      key: 'signatureInput',
      widget: <SignatureWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('signatureInput'), disabled: true })} isDisabled={true} />
    }
  ];

  try {
    const gateEnabled = await StatsigService.checkGate('3-pt_rating_scale');
    if (gateEnabled) {
      baseInputs.push({
        key: 'ratingScale3pt',
        widget: <Rating3ptWidget field={new Field({ ...ModelPlaceholders.getFieldPlaceholder('ratingScale3pt'), disabled: true })} isDisabled={true} />
      });
    }
  } catch (error) {
    console.warn('Statsig gate check failed:', error);
  }

  return baseInputs;
};

const disabledHeaders = [
  {
    key: 'sectionDivider',
    widget: <SectionWidget section={new Field(ModelPlaceholders.getFieldPlaceholder('sectionDivider'))} isDisabled={true} />
  },
  {
    key: 'pageBreak',
    widget: <PageBreakWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('pageBreak'))} isDisabled={true} />
  },
  {
    key: 'freeText',
    widget: <FormDescriptionWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('freeText'))} isDisabled={true} />
  },
  {
    key: 'fileEmbedded',
    widget: <FileEmbeddedWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('fileEmbedded'))} isDisabled={true} />
  },
  {
    key: 'userName',
    widget: <UserNameWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('userName'))} isDisabled={true} />
  }
];

const disabledProperties = [
  {
    key: 'propertyName',
    widget: <PropertyNameWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('propertyName'))} isDisabled={true} />
  },
  {
    key: 'pmsPropertyId',
    widget: <PMSPropertyIdWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('pmsPropertyId'))} isDisabled={true} />
  },
  {
    key: 'propertyAddress',
    widget: <PropertyAddressWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('propertyAddress'))} isDisabled={true} />
  },
  {
    key: 'propertyInfo',
    widget: <PropertyInfoWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('propertyInfo'))} isDisabled={true} />
  }
];

const disabledUnits = [
  {
    key: 'unitNumber',
    widget: <UnitNumberWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('unitNumber'))} isDisabled={true} />
  },
  {
    key: 'unitBuilding',
    widget: <UnitBuildingWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('unitBuilding'))} isDisabled={true} />
  },
  {
    key: 'unitInfo',
    widget: <UnitInfoWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('unitInfo'))} isDisabled={true} />
  }
];

const disabledTenants = [
  {
    key: 'tenantId',
    widget: <TenantIdWidget field={new Field(ModelPlaceholders.getFieldPlaceholder('tenantId'))} isDisabled={true} />
  }
];

class FieldWidgetService {
  static getWidget = (
    field,
    api,
    triggerTemplates,
    propertyFields,
    contactTypes,
    chargeCodes,
    pmsPlatforms,
    unitFields,
    indexInSection,
    descriptionAsIcon,
    showTriggerConditionMet
  ) => {
    const defaultValue = (field.defaultValue && field.defaultValue.value) ? field.defaultValue.value : field.defaultValue;
    const value = Array.isArray(defaultValue) ? defaultValue.join(',') : defaultValue;
    switch (field.component) {
      case 'textInput':
        return (
          <TextWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'phoneInput':
        let widthOptionsNewPhone = field.displayWidthOptions;
        let newPhone = angular.copy(field);
        newPhone.disabled = true;
        newPhone.displayWidthOptions = widthOptionsNewPhone;
        return (
          <PhoneWidgetEditable
            field={newPhone}
            api={api}
            triggerTemplates={triggerTemplates}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            contactTypes={contactTypes}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'textArea':
        return (
          <TextAreaWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'checkbox':
        let newCheckboxField = angular.copy(field);
        if (!Utils.isNull(field.defaultValue)) {
        newCheckboxField.defaultValue = [];
        field.options.forEach((item, key) => {
          if ((value.includes(key) || (value.includes(key.toString())) )) {
            newCheckboxField.defaultValue.push(item.value);
          }
          else if (value.includes(item.value)) {
            newCheckboxField.defaultValue.push(item.value);
          }
        })
        newCheckboxField.defaultValue = newCheckboxField.defaultValue.toString();

      };
        return (
          <CheckboxWidgetEditable
            field={newCheckboxField}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'checkboxJustifiedLeft':
        let widthOptionsNewCheckbox = field.displayWidthOptions;
        let newCheckbox = angular.copy(field);
        newCheckbox.displayWidthOptions = widthOptionsNewCheckbox;
        if (!Utils.isNull(field.defaultValue)) {
          newCheckbox.defaultValue = [];
          field.options.forEach((item, key) => {
            if ((value.includes(key) || (value.includes(key.toString())) )) {
              newCheckbox.defaultValue.push(item.value);
            }
            else if (value.includes(item.value)) {
              newCheckbox.defaultValue.push(item.value);
            }
          })
          newCheckbox.defaultValue = newCheckbox.defaultValue.toString();
        };
        return (
          <CheckboxWidgetEditable
            field={newCheckbox}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'radio':
        let newRadioField = angular.copy(field);
        if (!Utils.isNull(field.defaultValue)) {
        field.options.map((item, key) => {
          if ((key == value)|| (item.value == value)) {
            newRadioField.defaultValue = item.value;
          }
        })
      };
        return (
          <RadioWidgetEditable
            field={newRadioField}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            propertyFields={propertyFields}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'radioJustifiedLeft':
        let widthOptionsNewRadio = field.displayWidthOptions;
        let newRadio = angular.copy(field);
        newRadio.vertical = true;
        newRadio.displayWidthOptions = widthOptionsNewRadio;
        if (!Utils.isNull(field.defaultValue)) {
        field.options.map((item, key) => {
          if ((key == value)|| (item.value == value)) {
            newRadio.defaultValue = item.value;
          }
        })
      }
        return (
          <RadioWidgetEditable
            field={newRadio}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            propertyFields={propertyFields}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'select':
        let newSelectField = angular.copy(field);
        if (!Utils.isNull(field.defaultValue)) {
        field.options.map((item, key) => {
          if ((key == value)|| (item.value == value)) {
            newSelectField.defaultValue = item.value;
          }
        })
      };
        return (
          <SelectWidgetEditable
            field={newSelectField}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'numberInput':
        return (
          <NumberWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'currencyInput':
        return (
          <CurrencyWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'sliderRange':
        return (
          <SliderRangeWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'starRate':
        return (
          <StarsWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'dateInput':
        return (
          <DateWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'dateTimeInput':
        return (
          <DateTimeWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'timeInput':
        return (
          <TimeWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'fileImageInput':
        let widthOptionsFileImage = field.displayWidthOptions;
        let newFileImage = angular.copy(field);
        newFileImage.disabled = true;
        newFileImage.displayWidthOptions = widthOptionsFileImage;
        return (
          <FileImageWidgetEditable
            field={newFileImage}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'fileInput':
        let widthOptionsFileInput = field.displayWidthOptions;
        let newFile = angular.copy(field);
        newFile.disabled = true;
        newFile.image = Utils.isNull(newFile.image) ? false : newFile.image;
        newFile.multiple = Utils.isNull(newFile.multiple) ? false : newFile.multiple;
        newFile.displayWidthOptions = widthOptionsFileInput;
        return (
          <FileImageWidgetEditable
            field={newFile}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'imageInput':
        let widthOptionsImageInput = field.displayWidthOptions;
        let newPhoto = angular.copy(field);
        newPhoto.disabled = true;
        newPhoto.image = Utils.isNull(newPhoto.image) ? true : newPhoto.image;
        newPhoto.multiple = Utils.isNull(newPhoto.multiple) ? false : newPhoto.multiple;
        newPhoto.displayWidthOptions = widthOptionsImageInput;
        return (
          <FileImageWidgetEditable
            field={newPhoto}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'imageMultipleInput':
        let widthOptionsImageMultiple = field.displayWidthOptions;
        let newFileMultiple = angular.copy(field);
        newFileMultiple.disabled = true;
        newFileMultiple.image = Utils.isNull(newFileMultiple.image) ? true : newFileMultiple.image;
        newFileMultiple.multiple = Utils.isNull(newFileMultiple.multiple) ? true : newFileMultiple.multiple;
        newFileMultiple.displayWidthOptions = widthOptionsImageMultiple;
        return (
          <FileImageWidgetEditable
            field={newFileMultiple}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'ratingScale3pt':
        return (
          <Rating3ptWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'signatureInput':
        return (
          <SignatureWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
      case 'sectionDivider':
        return <SectionWidgetEditable section={field} api={api}/>;
      case 'pageBreak':
        return <PageBreakWidgetEditable field={field} api={api} indexInSection={indexInSection}/>;
      case 'freeText':
        return <FormDescriptionWidgetEditable field={field} api={api} indexInSection={indexInSection} descriptionAsIcon={descriptionAsIcon}/>;
      case 'fileEmbedded':
        return <FileEmbeddedWidgetEditable field={field} api={api} indexInSection={indexInSection} descriptionAsIcon={descriptionAsIcon}/>;
      case 'propertyName':
        return <PropertyNameWidgetEditable field={field} api={api} indexInSection={indexInSection} />;
      case 'pmsPropertyId':
        return <PMSPropertyIdWidgetEditable field={field} api={api} indexInSection={indexInSection}/>;
      case 'propertyAddress':
        return <PropertyAddressWidgetEditable field={field} api={api} indexInSection={indexInSection}/>;
      case 'propertyInfo':
        return <PropertyInfoWidgetEditable field={field} api={api} propertyFields={propertyFields} indexInSection={indexInSection}/>;
      case 'userName':
        return <UserNameWidgetEditable field={field} api={api} indexInSection={indexInSection}/>;
      case 'unitNumber':
        return <UnitNumberWidgetEditable field={field} api={api} indexInSection={indexInSection}/>;
      case 'unitBuilding':
        return <UnitBuildingWidgetEditable field={field} api={api} indexInSection={indexInSection}/>;
      case 'unitInfo':
        return <UnitInfoWidgetEditable field={field} api={api} unitFields={unitFields} indexInSection={indexInSection}/>;
      case 'tenantId':
        return <TenantIdWidgetEditable field={field} api={api} indexInSection={indexInSection} />;  
      default:
        return (
          <TextWidgetEditable
            field={field}
            api={api}
            triggerTemplates={triggerTemplates}
            contactTypes={contactTypes}
            chargeCodes={chargeCodes}
            pmsPlatforms={pmsPlatforms}
            indexInSection={indexInSection}
            descriptionAsIcon={descriptionAsIcon}
            showTriggerConditionMet={showTriggerConditionMet}
          />
        );
    }
  };

  static getAllDisabledWidgets = async (type) => {
    switch (type) {
      case 'inputs':
        return await getDisabledInputs();
      case 'headers':
        return disabledHeaders;
      case 'property':
        return disabledProperties;
      case 'unit':
        return disabledUnits;
      case 'resident':
        return disabledTenants;
    }
  };
}

export default FieldWidgetService;
